import store from './index.js'

const getters = {
    addRouters: (state) =>{
        if(state.router.addRouters.length === 0){
            store.dispatch('router/GenerateRoutes')
        }
        return state.router.addRouters
    },
}

export default getters